/* ********************** DEV INFORMATION ***********************

THIS COULD BE IMPROVED.
DUE TO NO TIME TO FINISH, I'VE DONE IT CUSTOM.

*********************** DEV INFORMATION *********************** */

class ProductComparator extends HTMLElement {
    constructor() {
        super()
        this.container          = this.querySelector('.product-comparator .is-mobile');
        this.metafieldData      = JSON.parse(this.container.querySelector('[data-product-compare-json]').textContent)
        this.selectors          = this.container.querySelectorAll('.product-comparator__select');
        this.firstColumnSelect  = this.container.querySelector('.product-comparator__swatchs[data-selector="1"] .product-comparator__select');
        this.secondColumnSelect = this.container.querySelector('.product-comparator__swatchs[data-selector="2"] .product-comparator__select');

        if (!!!this.container || !!!this.metafieldData || this.selectors.length === 0) return

        window.innerWidth < 990 && this.init()
    }

    cleanId(id) {
        return Number(id.replaceAll('gid://shopify/Product/', ''))
    }

    validateSelectValues(selectChanged, productId) {
        if (selectChanged === this.firstColumnSelect) {
            const selectOptions = [...this.secondColumnSelect.options];
            selectOptions.forEach(x => x.disabled = false)
            selectOptions.find(x => Number(x.value) === Number(productId)).disabled = true

            return this.changeProductToCompare(selectChanged, productId)
        }

        const selectOptions = [...this.firstColumnSelect.options];
        selectOptions.forEach(x => x.disabled = false)
        selectOptions.find(x => Number(x.value) === Number(productId)).disabled = true

        return this.changeProductToCompare(selectChanged, productId)
    }

    changeProductToCompare(selectChanged, productId) {
        const productInformation = Object.values($Collection.allProducts).find(x => x.id === productId)
        if (!!!productInformation || !!!selectChanged) return

        const columnToUpdate = selectChanged.closest('.product-comparator__selector');
        if (!!!columnToUpdate) return

        const productImage = columnToUpdate.querySelector('img');
        const productForm = columnToUpdate.querySelector('product-form form');
        const productFormId = columnToUpdate.querySelector('input[type="hidden"][name="id"]')
        const productButton = columnToUpdate.querySelector('.product-form__buttons button');

        columnToUpdate.dataset.id = productInformation.id
        productImage.src = productInformation.featured_image
        productForm.id = `product-form-${ productInformation.id }`
        productFormId.value = productInformation.first_available_variant.id
        productButton.disabled = !productInformation.available

        this.changeProductPrices(columnToUpdate, productInformation)
        this.changeProductInformationToCompare(columnToUpdate, productInformation)
        return
    }

    changeProductInformationToCompare(columnToUpdate, product) {
        const numberOfColumnToUpdate = columnToUpdate.closest('.product-comparator__swatchs').dataset.selector;

        const allProductFeatures = this.container.querySelectorAll('.product-comparator__feature');
        [...allProductFeatures].forEach(x => {
            const productFeatureWrapper = x.querySelector(`.product-comparator__wrapper[data-related-id="${ product.id }"]`)
            productFeatureWrapper.dataset.column = numberOfColumnToUpdate
            productFeatureWrapper.style.order = numberOfColumnToUpdate
            productFeatureWrapper.classList.remove('hidden')

            const productFeatureWrapperToHide = x.querySelector(`.product-comparator__wrapper[data-column="${ numberOfColumnToUpdate }"]:not([data-related-id="${ product.id }"])`)

            if (!!!productFeatureWrapperToHide || Number(productFeatureWrapperToHide.dataset.relatedId) === product.id) return

            productFeatureWrapperToHide.dataset.column = '0'
            productFeatureWrapperToHide.classList.add('hidden')
        })
    }

    changeProductPrices(columnToUpdate, product) {
        const priceContainer = columnToUpdate.querySelector('.price')
        const priceRegular = priceContainer.querySelectorAll('.price-item--regular')
        const priceSale = priceContainer.querySelector('.price-item--sale')

        product.compare_at_price > product.price ? priceContainer.classList.add('price--on-sale') : priceContainer.classList.remove('price--on-sale')

        if (priceContainer.classList.contains('price--on-sale')) {
            [...priceRegular].forEach(x => x.textContent = product.compare_at_price_with_money)
            priceSale.textContent = product.price_with_money

            return
        }

        priceRegular.textContent = product.price_with_money
    }

    setListeners() {
        this.selectors.forEach(selector => {
            selector.addEventListener('change', (evt) => {
                const selectChanged = evt.target
                const selectedProduct = evt.target.value;
                const selectedProductData = this.metafieldData.find(x => this.cleanId(x.product) === Number(selectedProduct));

                if (!!!selectedProductData) return
                this.validateSelectValues(selectChanged, this.cleanId(selectedProductData.product))
            })
        })
    }

    init() {
        this.setListeners()
    }
}

customElements.define('product-comparator', ProductComparator);
